import { Link } from "react-router-dom";
import { Facebook, Youtube } from "lucide-react";

// lucide has no TikTok logo: small inline icon, same size as the others.
const TikTok = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.77a5.7 5.7 0 0 0-.77-.05 5.69 5.69 0 1 0 5.69 5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.25-1.48z" />
    </svg>
);

// Official MBOAZICK accounts. Leave a URL empty to hide its icon.
const SOCIAL_LINKS = [
    { label: "Facebook", url: "https://www.facebook.com/share/18g818Z4tu/", Icon: Facebook },
    { label: "TikTok", url: "https://www.tiktok.com/@mboazick", Icon: TikTok },
    { label: "YouTube", url: "https://www.youtube.com/@mboazick", Icon: Youtube },
];
import { openCookiePreferences } from "./CookieConsent";

export default function Footer() {
    return (
        <footer className="border-t border-[#262626] bg-[#0F0F0F] mt-32" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
                <div className="col-span-2">
                    <img decoding="async" loading="lazy" src="/mboa-zick-logo.png" alt="MBOAZICK" className="h-14 w-auto" />
                    <p className="mt-5 text-sm text-[#A8A8A8] max-w-xs leading-relaxed">
                        La plateforme des artistes africains : vends ta musique, reçois le soutien de tes fans, sois payé par Mobile Money.
                    </p>
                    {SOCIAL_LINKS.some((l) => l.url) && (
                        <div className="flex items-center gap-3 mt-6">
                            {SOCIAL_LINKS.filter((l) => l.url).map(({ label, url, Icon }) => (
                                <a key={label} href={url} target="_blank" rel="noopener noreferrer" className="p-2 border border-[#262626] rounded-full hover:border-[#00A86B] transition-colors" aria-label={label}>
                                    <Icon className="w-4 h-4" strokeWidth={1.5} />
                                </a>
                            ))}
                        </div>
                    )}
                </div>

                <FooterCol title="Plateforme" items={[
                    { to: "/producers", label: "Annuaire pros" },
                    { to: "/opportunites", label: "Opportunités" },
                    { to: "/playlist", label: "Playlist" },
                    { to: "/artiste-du-mois", label: "🏆 Artiste du Mois" },
                    { to: "/beats", label: "MBOA BEAT — Instrus exclusives" },
                    { to: "/services", label: "Services Pro — Business Suite" },
                    { to: "/catalog", label: "Catalogue" },
                ]} />
                <FooterCol title="Communauté" items={[
                    { to: "/about", label: "À propos" },
                    { to: "/become-artist", label: "Devenir pro" },
                    { to: "/entrevue", label: "Entrevue artiste 🎬" },
                    { to: "/blog", label: "Blog" },
                    { to: "/faq", label: "Aide & FAQ" },
                    { to: "/contact", label: "Contact" },
                ]} />
                <FooterCol title="Légal" items={[
                    { to: "/terms", label: "CGU" },
                    { to: "/privacy", label: "Confidentialité" },
                    { to: "/legal", label: "Mentions légales" },
                ]} />
            </div>
            <div className="border-t border-[#262626]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#6E6E6E]">
                    <p>© {new Date().getFullYear()} MBOAZICK — La plateforme pro des artistes africains.</p>
                    <div className="flex items-center gap-4">
                        <button
                            type="button"
                            onClick={openCookiePreferences}
                            className="text-[#A8A8A8] hover:text-[#F4F4F4] underline underline-offset-2 transition-colors"
                            data-testid="footer-cookie-preferences"
                        >
                            Gérer mes cookies
                        </button>
                        <span>Paiement sécurisé — Mobile Money &amp; cartes</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

function FooterCol({ title, items }) {
    return (
        <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00d97e] mb-4">{title}</p>
            <ul className="space-y-2.5">
                {items.map((i) => (
                    <li key={i.label}>
                        <Link to={i.to} className="text-sm text-[#A8A8A8] hover:text-[#F4F4F4] transition-colors">
                            {i.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
